<template>
  <div class="my-5">
    <h2 class="subtitle has-text-centered">Customize</h2>
    <div class="tabs is-centered">
      <ul>
        <li v-bind:class="{ 'is-active': activeTab == 0 }">
          <a @click.prevent="activeTab = 0">1. Rating</a>
        </li>
        <li v-bind:class="{ 'is-active': activeTab == 1 }">
          <a @click.prevent="activeTab = 1">2. Extended Feedback</a>
        </li>
        <li
          v-bind:class="{ 'is-active': activeTab == 2 }"
          @click.prevent="activeTab = 2"
        >
          <a>3. Thank You</a>
        </li>
        <li v-bind:class="{ 'is-active': activeTab == 3 }">
          <a @click.prevent="activeTab = 3">Advanced</a>
        </li>
      </ul>
    </div>
    <div>
      <div v-if="activeTab == 0">
        <div class="columns is-variable is-8 is-multiline">
          <div class="column">
            <div class="field">
              <label class="label" for="thumbsParagraph"
                >Rating Type</label
              >
              <div class="control">
                <label class="radio">
                  <input type="radio" :disabled="feedbackForm.formId" name="ratingType" v-model="feedbackForm.webRatingType" @change="changeRatingtype('thumbs')" value="thumbs">
                  Thumbs
                </label>
                <label class="radio">
                  <input type="radio" :disabled="feedbackForm.formId" name="ratingType" v-model="feedbackForm.webRatingType" @change="changeRatingtype('5emojis')" value="5emojis">
                  5 Emojis
                </label>
                <label class="radio">
                  <input type="radio" :disabled="feedbackForm.formId" name="ratingType" v-model="feedbackForm.webRatingType" @change="changeRatingtype('5stars')" value="5stars">
                  5 Stars
                </label>
              </div>
            </div>
            <div class="field">
              <label class="label" for="thumbsHeadline"
                >Introduction Headline</label
              >
              <div class="control">
                <input
                  v-model="feedbackForm.thumbsHeadline"
                  id="thumbsHeadline"
                  name="thumbsHeadline"
                  type="text"
                  placeholder="placeholder"
                  class="input"
                  required
                />
              </div>
            </div>


          </div>
          <div class="column">
            <h2 class="subtitle">Preview</h2>

            <div id="formWidgetAlt" class="content is-medium">
            <iframe
              id="step1Preview"
              @load="setStep1Preview(feedbackForm)"
              class="wr-previewFrame"
              src="/previews/webrating-1.html"
            >
            </iframe>
              </div>
          </div>
        </div>
      </div>

      <div v-if="activeTab == 1">
        <div class="columns is-variable is-8 is-multiline">
          <div class="column">
            <div class="field">
              <label v-if="isThumbsRating" class="label" for="thumbsupReasonHeader">Headline when Thumbs Up</label>
              <label v-else-if="is5StarRating" class="label" for="thumbsupReasonHeader"
                >Headline when 5-⭐</label
              >
              <label v-else class="label" for="thumbsupReasonHeader"
                >Headline when Love Smiley</label
              >
              <div class="control">
                <input
                  v-model="feedbackForm.efpThumbsupReasonHeader"
                  id="thumbsupReasonHeader"
                  name="thumbsupReasonHeader"
                  type="text"
                  class="input"
                />
              </div>
            </div>

            <div class="field">
              <label v-if="isThumbsRating" class="label" for="thumbsokReasonHeader">Headline when Thumbs Ok</label>
              <label v-else-if="is5StarRating" class="label" for="thumbsupReasonHeader"
                >Headline when 4-⭐</label
              >
              <label v-else class="label" for="thumbsokReasonHeader"
                >Headline when Happy Smiley</label
              >
              <div class="control">
                <input
                  v-model="feedbackForm.efpThumbsokReasonHeader"
                  id="thumbsokReasonHeader"
                  name="thumbsokReasonHeader"
                  type="text"
                  class="input"
                />
              </div>
            </div>

            <div class="field">
              <label v-if="isThumbsRating" class="label" for="thumbsdownReasonHeader">Headline when Thumbs Down</label>
              <label v-else-if="is5StarRating" class="label" for="thumbsupReasonHeader"
                >Headline when 3-⭐</label
              >
              <label v-else class="label" for="thumbsdownReasonHeader"
                >Headline when Neutral Smiley</label
              >
              <div class="control">
                <input
                  v-model="feedbackForm.efpThumbsdownReasonHeader"
                  id="thumbsdownReasonHeader"
                  name="thumbsdownReasonHeader"
                  type="text"
                  placeholder="placeholder"
                  class="input"
                />
              </div>
            </div>
            <div v-if="!isThumbsRating" class="field">
              <label v-if="is5StarRating" class="label" for="thumbsupReasonHeader"
                >Headline when 2-⭐</label
              >
              <label v-else class="label" for="efpThumbsoption4ReasonHeader"
                >Headline when Sad Smiley
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpThumbsoption4ReasonHeader"
                  id="efpThumbsoption4ReasonHeader"
                  name="efpThumbsoption4ReasonHeader"
                  type="text"
                  class="input"
                />
              </div>
            </div>
            <div v-if="!isThumbsRating" class="field">
              <label v-if="is5StarRating" class="label" for="thumbsupReasonHeader"
                >Headline when 1-⭐</label
              >
              <label v-else class="label" for="efpThumbsoption5ReasonHeader"
                >Headline when Angry Smiley

              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpThumbsoption5ReasonHeader"
                  id="efpThumbsoption5ReasonHeader"
                  name="efpThumbsoption5ReasonHeader"
                  type="text"
                  class="input"
                />
              </div>
            </div>
            <div class="field">
              <label class="label" for="efpReaderNamePlaceholder"
                >Gather Reader's Name Placeholder
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpReaderNamePlaceholder"
                  id="efpReaderNamePlaceholder"
                  name="efpReaderNamePlaceholder"
                  type="text"
                  class="input"
                  :disabled="!account.has_pro_features"
                />
              </div>
            </div>
          <div class="field">
              <label class="label" for="efpReaderEmailPlaceholder"
                >User's Email Address Placeholder
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpReaderEmailPlaceholder"
                  id="efpReaderEmailPlaceholder"
                  name="efpReaderEmailPlaceholder"
                  type="text"
                  class="input"
                  :disabled="!account.has_pro_features"
                />
              </div>
              <p class="help">
                Leave the field empty to hide the input box on the extended feedback page.
              </p>
            </div>
            <div class="field">
              <label class="label" for="efpButtonText"
                >Button Text
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpButtonText"
                  id="efpButtonText"
                  name="efpButtonText"
                  type="text"
                  class="input"
                  :disabled="!account.has_pro_features"
                />
              </div>
            </div>

          </div>
          <div class="column">
            <h2 class="subtitle">Preview</h2>

            <iframe
              id="efpPreview"
              @load="setEfpPreview(feedbackForm)"
              class="wr-previewFrame"
              src="/previews/webrating-2.html"
            >
            </iframe>
          </div>
        </div>
      </div>
      <div v-if="activeTab == 2">
        <div class="columns is-variable is-8 is-multiline">
          <div class="column">
            <div class="field">
              <label class="label" for="typHeadline"
                >Headline
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.typHeadline"
                  id="typHeadline"
                  name="typHeadline"
                  type="text"
                  class="input"
                  :disabled="!account.has_pro_features"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <h2 class="subtitle">Preview</h2>

            <iframe
              id="typPreview"
              @load="setTypPreview(feedbackForm)"
              class="wr-previewFrame"
              src="/previews/webrating-3.html"
            >
            </iframe>
          </div>
        </div>
      </div>
      <div v-if="activeTab == 3">
        <div class="columns is-variable is-8 is-multiline">
          <div class="column is-half">
            <div class="field is-relative" id="efpNotificationEmailBlock">
              <label class="label" for="efpNotificationEmail"
                >Receive An Email On New Feedback
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpNotificationEmail"
                  id="efpNotificationEmail"
                  name="efpNotificationEmail"
                  type="email"
                  class="input"
                  placeholder="Enter an email address to be notified when a new extendend feedback is posted"
                  :disabled="!account.has_pro_features"
                />
                
              </div>
              <p class="help" >
                <a @click.prevent="sendTestNotificationEmail" >Send Test Email</a>
              </p>
            </div>
            <div class="field is-relative" id="efpNotificationWebhookBlock">
              <label class="label" for="efpNotificationWebhookURL"
                >Webhook On New Feedback
                <span
                  v-if="!account.has_biz_features"
                  class="tag is-warning"
                  >BIZ</span
                >
                <router-link
                  v-if="!account.has_biz_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpNotificationWebhookURL"
                  id="efpNotificationWebhookURL"
                  name="efpNotificationWebhookURL"
                  type="url"
                  class="input"
                  placeholder="Enter a URL that accept the feedback webhook"
                  :disabled="!account.has_biz_features"
                />
              </div>
              <p class="help" >
                <a @click.prevent="sendTestNotificationWebhook" >Send Test Webhook</a>
              </p>
              <p class="help">More detials in the <a href="/integrations/">help section for Integrations</a>
              </p>
            </div>
            <div class="field">
              <label class="label" for="wrShowWidgetTime"
                >Show Widget After X Seconds
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.wrShowWidgetTime"
                  id="wrShowWidgetTime"
                  name="wrShowWidgetTime"
                  type="number"
                  class="input"
                  :disabled="!account.has_pro_features"
                />
              </div>
              <p class="help">
                Time in seconds after which the widget is show. Enter -1 to disable auto show.
              </p>
            </div>
            <div class="field">
              <label class="label" for="wrEnableReviewSchema"
                >Enable Review Schema for Search
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <label class="radio">
                  <input type="radio" name="wrEnableReviewSchema" v-model="feedbackForm.wrEnableReviewSchema" value="1" :disabled="!account.has_pro_features">
                  yes
                </label>
                <label class="radio">
                  <input type="radio" name="wrEnableReviewSchema" v-model="feedbackForm.wrEnableReviewSchema" value="0" :disabled="!account.has_pro_features">
                  no
                </label>
              </div>
              <p class="help">
                If enabled, adds a JSON-ld review schema to the page. Displays star ratings in Google Search.
              </p>
            </div>
            <div class="field">
              <label class="label" for="wrShowBranding"
                >Show FeedLetter Branding
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <label class="radio">
                  <input type="radio" name="wrShowBranding" v-model="feedbackForm.wrShowBranding" value="1" :disabled="!account.has_pro_features">
                  yes
                </label>
                <label class="radio">
                  <input type="radio" name="wrShowBranding" v-model="feedbackForm.wrShowBranding" value="0" :disabled="!account.has_pro_features">
                  no
                </label>
              </div>
              <p class="help">
                You can remove the FeedLetter branding on the widget.
              </p>
            </div>
            <div class="field">
              <label class="label" for="wrEmailMandatory"
                >Make the Email Field Mandatory
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <label class="radio">
                  <input type="radio" name="wrEmailMandatory" v-model="feedbackForm.wrEmailMandatory" value="1" :disabled="!account.has_pro_features">
                  yes
                </label>
                <label class="radio">
                  <input type="radio" name="wrEmailMandatory" v-model="feedbackForm.wrEmailMandatory" value="0" :disabled="!account.has_pro_features">
                  no
                </label>
              </div>
              <p class="help">
                Users need to enter an email address to send the feedback.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import atomic from "atomicjs"
import { mapState } from 'vuex'
import { trackEvent } from '../lib/flevents';

export default {
  props: ["feedbackForm",],
  components: {},
  data: function () {
    return {
      activeTab: 0,
    };
  },
  methods: {
    setStep1Preview: function (newFeedbackForm) {
      let iframe = document.getElementById("step1Preview");
      if (iframe != null) {
        let step1PreviewFrame =
          iframe.contentDocument || iframe.contentWindow.document;
          let hl = step1PreviewFrame.getElementById("thumbsHeadline")
          if (hl !== null) {
            hl.innerText =
              newFeedbackForm.thumbsHeadline;
          }

        let vb = step1PreviewFrame.getElementById("voteBlock")

        if(vb !== null) {
          var voteBlock = `
            <li>
              <a>${ newFeedbackForm.thumbsup }</a>
            </li>
            <li>
              <a>${ newFeedbackForm.thumbsok }</a>
            </li>
            <li>
              <a>${ newFeedbackForm.thumbsdown }</a>
          </li>`
          if (newFeedbackForm.webRatingType === "5emojis") {
            voteBlock = `
            <li>
              <a>${ newFeedbackForm.thumbsoption5 }</a>
            </li>
            <li>
              <a>${ newFeedbackForm.thumbsoption4 }</a>
            </li>
            <li>
              <a>${ newFeedbackForm.thumbsdown }</a>
            </li>
            <li>
              <a>${ newFeedbackForm.thumbsok }</a>
            </li>
            <li>
              <a>${ newFeedbackForm.thumbsup }</a>
            </li>`
          } else if (newFeedbackForm.webRatingType === "5stars") {
            voteBlock = `
    <li>
      <a><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg></a>
    </li>
    <li>
      <a><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg></a>
    </li>
    <li>
      <a><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg></a>
    </li>
    <li>
      <a><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg></a>
    </li>
    <li>
      <a><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg></a>
    </li>`
          }

          if(newFeedbackForm.webRatingType === "5stars") {
            vb.classList.add("feedletter-5stars")
          } else {
            vb.classList.remove("feedletter-5stars")
          }
          vb.innerHTML= voteBlock
        }

      }
    },
    setEfpPreview: function (newFeedbackForm) {
      let iframe = document.getElementById("efpPreview");
      if (iframe != null) {
        let efpPreviewFrame =
          iframe.contentDocument || iframe.contentWindow.document;
        efpPreviewFrame.getElementById("feedletter-message-99").innerText =
          newFeedbackForm.efpThumbsupReasonHeader;
        efpPreviewFrame.getElementById("efpButtonText").innerText =
          newFeedbackForm.efpButtonText;

        efpPreviewFrame.getElementById("feedletter-email-99").placeholder =
          newFeedbackForm.efpReaderEmailPlaceholder || ""
        if (newFeedbackForm.efpReaderEmailPlaceholder === undefined || newFeedbackForm.efpReaderEmailPlaceholder === null
        || newFeedbackForm.efpReaderEmailPlaceholder === "") {
          efpPreviewFrame.getElementById("feedletter-email-99").style.display = "none"
        } else {
          efpPreviewFrame.getElementById("feedletter-email-99").style.display = "block"
        }

        efpPreviewFrame.getElementById("feedletter-name-99").placeholder =
          newFeedbackForm.efpReaderNamePlaceholder || ""
        if (newFeedbackForm.efpReaderNamePlaceholder === undefined || newFeedbackForm.efpReaderNamePlaceholder === null
        || newFeedbackForm.efpReaderNamePlaceholder === "") {
          efpPreviewFrame.getElementById("feedletter-name-99").style.display = "none"
        } else {
          efpPreviewFrame.getElementById("feedletter-name-99").style.display = "block"
        }
      }
    },
    setTypPreview: function (newFeedbackForm) {
      let iframe = document.getElementById("typPreview");
      if (iframe != null) {
        let typPreviewFrame =
          iframe.contentDocument || iframe.contentWindow.document;
        typPreviewFrame.getElementById("typHeadline").innerText =
          newFeedbackForm.typHeadline;
      }
    },
    changeRatingtype: function (webRatingType) {
      if (webRatingType === "5emojis") {
        this.feedbackForm.thumbsup = "😍"
        this.feedbackForm.thumbsok = "😀"
        this.feedbackForm.thumbsdown = "😐"
        this.feedbackForm.thumbsoption4 = "😟"
        this.feedbackForm.thumbsoption5 = "😡"
        this.feedbackForm.efpThumbsupReasonHeader = "What do you love about it?"
        this.feedbackForm.efpThumbsokReasonHeader = "What do you like about it?"
        this.feedbackForm.efpThumbsdownReasonHeader = "What's missing for you?"
        this.feedbackForm.efpThumbsoption4ReasonHeader = "What did you not like about it?"
        this.feedbackForm.efpThumbsoption5ReasonHeader = "What did you hate about it?"
        if(this.subscribed) {
          this.feedbackForm.efpReaderEmailPlaceholder = "Enter your email if you want a reply"
          this.feedbackForm.efpReaderNamePlaceholder = "Enter your name or stay anonymous"
          
        }
      } else if (webRatingType === "5stars") {
        this.feedbackForm.thumbsup = "5-⭐"
        this.feedbackForm.thumbsok = "4-⭐"
        this.feedbackForm.thumbsdown = "3-⭐"
        this.feedbackForm.thumbsoption4 = "2-⭐"
        this.feedbackForm.thumbsoption5 = "1-⭐"
        this.feedbackForm.efpThumbsupReasonHeader = "What do you love about it?"
        this.feedbackForm.efpThumbsokReasonHeader = "What do you like about it?"
        this.feedbackForm.efpThumbsdownReasonHeader = "What's missing for you?"
        this.feedbackForm.efpThumbsoption4ReasonHeader = "What did you not like about it?"
        this.feedbackForm.efpThumbsoption5ReasonHeader = "What did you hate about it?"
        if(this.subscribed) {
          this.feedbackForm.efpReaderEmailPlaceholder = "Enter your email if you want a reply"
          this.feedbackForm.efpReaderNamePlaceholder = "Enter your name or stay anonymous"
        } 
      } else {
        this.feedbackForm.thumbsup = "👍"
        this.feedbackForm.thumbsok = "😐"
        this.feedbackForm.thumbsdown = "👎"
        this.feedbackForm.thumbsoption4 = null
        this.feedbackForm.thumbsoption5 = null
        this.feedbackForm.efpThumbsupReasonHeader = "What do you love about it?"
        this.feedbackForm.efpThumbsokReasonHeader = "What's missing for you?"
        this.feedbackForm.efpThumbsdownReasonHeader = "What did you hate it?"
        this.feedbackForm.efpThumbsoption4ReasonHeader = null
        this.feedbackForm.efpThumbsoption5ReasonHeader = null
        if(this.subscribed) {
          this.feedbackForm.efpReaderEmailPlaceholder = "Enter your email if you want a reply"
          this.feedbackForm.efpReaderNamePlaceholder = "Enter your name or stay anonymous"
        }
      }
    },
    sendTestNotificationEmail: async function() {

      if(this.isEmptyOrSpaces(this.feedbackForm.efpNotificationEmail)) {
        return
      }
      var self = this;
      let loadingComponent = this.$buefy.loading.open({
        container: document.getElementById("efpNotificationEmailBlock")
      })
      this.$store.dispatch('getAPIToken')
        .then((token) => {
          atomic(self.apiHost + "test/email?e=" + self.feedbackForm.efpNotificationEmail, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token
            },
          })
            .then(function (response) {
              loadingComponent.close()
              self.$buefy.toast.open({
                duration: 3000,
                message: `Test eMail notification was sent.`,
                type: 'is-success'
              })
              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              loadingComponent.close()
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            });
        })
        .catch((error) => {
          this.$parent.$emit("unauthed")
        });
    },
    sendTestNotificationWebhook: async function() {
      if(this.isEmptyOrSpaces(this.feedbackForm.efpNotificationWebhookURL)) {
        return
      }
      var self = this;

      let loadingComponent = this.$buefy.loading.open({
        container: document.getElementById("efpNotificationWebhookBlock")
      })
      this.$store.dispatch('getAPIToken')
        .then((token) => {
          atomic(self.apiHost + "test/webhook?h=" + self.feedbackForm.efpNotificationWebhookURL, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token
            },
          })
            .then(function (response) {
              loadingComponent.close()
              self.$buefy.toast.open({
                duration: 3000,
                message: `Test Webhook notification was sent.`,
                type: 'is-success'
              })
              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              loadingComponent.close()
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            });
        })
        .catch((error) => {
          this.$parent.$emit("unauthed")
        });
    }
  },
  computed: {
    ...mapState([
      "user",
      "account"
    ]),
    isThumbsRating() {
      return this.feedbackForm.webRatingType === "thumbs"
    },
    is5StarRating() {
      return this.feedbackForm.webRatingType === "5stars"
    },

  },
   created: function () {
     if(!this.feedbackForm.formId) {
      this.changeRatingtype(this.feedbackForm.webRatingType)
     }
   },
  watch: {
    // whenever question changes, this function will run
    feedbackForm: {
      handler(newFeedbackForm, oldVal) {
        this.setEfpPreview(newFeedbackForm)
        this.setTypPreview(newFeedbackForm)
        this.setStep1Preview(newFeedbackForm)
      },
      deep: true,
      immediate: true,
    },
    activeTab: function (val) {
      trackEvent(this.$store.state.user.id, "survey-edit-wr-tab-view-" + this.activeTab)
    }
  },
};
</script>
<style scoped>
</style>
